import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import PageLoader from "../component/loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addNewOrderUpdate, getDeliveryPercentList, getGoogleSheet, getOrderRemove, getOrdersList, getSymbolList } from "../action/api-services";
import moment from "moment";
import { setDeliveryDataReducer } from "../redux/slice/deliveryData";
import { useNavigate } from "react-router-dom";
import StockAction from "../component/stockAction";
import StockStrength from "../component/stockStrength";
import SectorPanchang from "../component/sectorPanchag";
import DeliveryGraph from "../component/deliveryGraph";
import { AIPromptForStock1, calculateLeaderScore, todayMarketHoldTime } from "../utils/constants";

const NewOrderPage = () => {
  const dispatch = useDispatch();
  const userToken = useSelector((state) => state.userToken.value);
  const [deliveryDataList, setDeliveryDataList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [todayTime, setTodayTime] = useState();
  const [maxDate, setMaxDate] = useState();
  const [todayData, setTodayData] = useState([]);
  const [symbolData, setSymbolData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [series, setSeries] = useState('EQ');
  const [getAddedNewOrder, setAddedNewOrder] = useState(false);

  const navigate = useNavigate();
  
  
  useEffect(() => {
            if (userToken){
                setLoader(true);
                setAddedNewOrder(false)
                Promise.all([
                    getGoogleSheet("", userToken),
                    getSymbolList(series, '', userToken),
                    getOrdersList(userToken),
                    getDeliveryPercentList('', 'neworder', '', '', series, '', userToken), // setups
                  ])
                  .then(([googleRes, symbolRes, orderRes, delivery]) => {
                    setMaxDate(googleRes.data.data.datetime);
                    setTodayTime(googleRes.data.data.datetime);
                    setTodayData(googleRes.data.data.json_data);
                    setSymbolData(symbolRes.data.data || []);
                    setOrderData(orderRes.data.data || []);
                   
                    setDeliveryDataList(delivery.data.data || []);
                    dispatch(setDeliveryDataReducer(delivery.data.data || []));


                    let deliveyData = delivery.data.data || [];
                    
                    let result = Array.isArray(orderRes?.data?.data)
                                ? orderRes.data.data
                                    // .filter(item => parseFloat(item.breakout_price) > 100)
                                    .map(item => {
                                            const deliveryList = Object.values(delivery?.data?.data || {});
                                            const dd = deliveryList.find(d => d.symbol === item.symbol);
                                            const scoreData = {
                                                  ...dd,
                                                  RSI: dd?.RSI || 0,
                                                  delivery_per: dd?.stock_data?.[0]?.delivery_per || 0,
                                                  prev_delivery_per: dd?.stock_data?.[1]?.delivery_per || 0,
                                                  ttl_trd_qty: dd?.stock_data?.[0]?.ttl_trd_qty || 0,
                                                  prev_volume: dd?.stock_data?.[1]?.ttl_trd_qty || 0,
                                              };
                                        return {
                                            ...item,
                                            score: calculateLeaderScore(scoreData)
                                        };
                                    })
                                : [];
  
                    setOrderData(result);
                  
                    
  
                  })
                  .catch(console.error)
                  .finally(() => setLoader(false));
            } else {
                  navigate(`/`);
            }
  
    }, [getAddedNewOrder, userToken]);
  

  const onSymbolCheckHandler = (e) =>{
        let symbolName = e.target.value;
        if(symbolName !== ''){
            let details = symbolData?.find((s) => s.symbol === symbolName);
            if(!details){
              toast.error(`The symbol ${symbolName} is not validated`);
            }
        }
  }

  const addNewOrderHandler = (e) =>{
    e.preventDefault();
    const form = e.target;
    if(form.elements.addnewsymbol.value ===''){
      toast.error("Symbol is required");
      return false;
    }

    let params = {
          symbol: form.elements.addnewsymbol.value,
          orderValue: form.elements.OrderValue.value,
          revenueImpact: form.elements.RevenueImpact.value,
          clientName: form.elements.Client.value,
          orderType: form.elements.type.value,
          order_date: moment().format('YYYY-MM-DD')
    };
     addNewOrderUpdate(params, userToken)
              .then(function (response) {
                // console.log(response.data);
                if(response.data.status === true){
                    // toast.success(response.data.message);
                    form.reset();
                    setAddedNewOrder(true)
                }else{
                    toast.error(response.data.message);
                }

      })
      .catch(function (err) {
        console.log("Error", err);
      });
    
      
  }

  const itemRemoveHandler = (e, id) =>{
      e.preventDefault();
      getOrderRemove({id: id}, userToken)
              .then(function (response) {
                if(response.data.status === true){
                    toast.success(response.data.message);
                    setAddedNewOrder(true)
                }else{
                    toast.error(response.data.message);
                }

      })
      .catch(function (err) {
        console.log("Error", err);
      });

      
  }
  


  return (
    <React.Fragment>
      <div className="pageContainer">
          <div className="container-fluid">
              <form onSubmit={(e) => addNewOrderHandler(e)}>
              <div className="row py-3">
                    <div className="col-2 pe-0">
                          <div className="form-floating">
                              <input
                                type="text"
                                className="form-control"
                                id="addnewsymbol"
                                placeholder="Symbol"
                                onBlur={(e) => onSymbolCheckHandler(e)}
                              />
                              <label htmlFor="addnewsymbol">Symbol</label>
                          </div>
                    </div>
                    <div className="col-2 pe-0">
                          <div className="form-floating">
                              <input
                                type="text"
                                className="form-control"
                                id="OrderValue"
                                placeholder="Order Value"
                              />
                              <label htmlFor="OrderValue">Order Value</label>
                          </div>
                    </div>
                    <div className="col-2 pe-0">
                          <div className="form-floating">
                              <input
                                type="text"
                                className="form-control"
                                id="RevenueImpact"
                                placeholder="Order Value"
                              />
                              <label htmlFor="RevenueImpact">Revenue Impact</label>
                          </div>
                    </div>
                    <div className="col-3 pe-0">
                          <div className="form-floating">
                              <input
                                type="text"
                                className="form-control"
                                id="Client"
                                placeholder="Order Value"
                              />
                              <label htmlFor="Client">Client</label>
                          </div>
                    </div>
                    <div className="col-2 pe-0">
                            <div className="form-floating">
                                <select
                                  className="form-control"
                                  id="type"
                                  // value={type}
                                  // onChange={e => setType(e.target.value)}
                                >
                                  <option value="New Order">New Order</option>
                                  <option value="Upcoming Tender">Upcoming Tender</option>
                              </select>
                              <label htmlFor="type">Type</label>
                          </div>
                    </div>
                    <div className="col" style={{width: '100px'}}>
                      <button type="submit" className="btn btn-primary px-4 w-100">Add</button>
                    </div>
              </div>
              </form>
          </div>
          
          
          <div className="pagewrap">
                <table className="increaseOI table-responsive">
                      <thead>
                        <tr key={`item_0`}>
                          <th style={{ width: "60px" }}>Datetime</th>
                          <th style={{ width: "128px" }}>Symbol </th>
                          <th style={{ width: "15px" }}></th>
                          <th style={{ width: "40px" }}></th>
                          <th style={{ width: "50px", textAlign: "left"}}>Strength</th>
                          <th style={{ width: "105px", textAlign: "left"}}>Sector</th>
                          <th style={{ width: "40px", textAlign: "left"}}>Indices</th>
                          <th style={{ width: "40px"}}>Score</th>
                          <th style={{ width: "40px"}}>Revenue</th>
                          <th style={{ width: "100px", textAlign: "left"}}>Order Type</th>
                          <th style={{ width: "87px", textAlign: "left"}}>Structure</th>
                          <th style={{ width: "55px" }}>Close</th>
                          <th style={{ width: "68px" }}>LTP</th>
                          <th style={{ width: "45px" }}>Chn%</th>
                          <th style={{ width: "56px" }}>T Chn%</th>
                          <th style={{ width: "42px" }}>EMA20</th>
                          <th style={{ width: "42px" }}>SMA50</th>
                          <th style={{ width: "58px" }}>Down 52</th>
                          <th style={{ width: "105px" }}>52 L/H</th>
                          <th style={{ width: "75px" }}>Vol</th>
                          <th style={{ width: "48px" }}>Del%</th>
                          <th style={{ width: "60px" }}>News</th>
                        </tr>
                      </thead>
                      <tbody>
                          {loader === true? (
                            <tr style={{background:"#FFF"}}><td colSpan={22} style={{textAlign:'center'}}><PageLoader /></td></tr>
                          ) : (
                            orderData?.map((obj, index) => {
                              // console.log(obj);
                              let symbolName = obj.symbol;
                              let details = symbolData?.find((s) => s.symbol === symbolName);
                              let todayLTP = todayData?.find((s) => s.TICKER === symbolName);

                              let deliverylist = Object.values(deliveryDataList);
                              let deliveryData = deliverylist?.find((s) => s.symbol === symbolName);
                              let Structure = deliveryData?.structure_json || [];
                              let EMA21Cross = parseFloat(deliveryData?.EMA20) > parseFloat(deliveryData?.SMA20);

                              let high52w = details?.high52w? details?.high52w: 0;
                              let low52w = details?.low52w? details?.low52w: 0;
                              let highDate = details?.highDate? moment(details?.highDate).format("DD-MM-YY"): "";
                              let lowDate = details?.lowDate? moment(details?.lowDate).format("DD-MM-YY"): "";
                              let high52wPer = (((high52w - todayLTP?.LTP) * 100) / high52w);

                              let Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? todayLTP?.VOLUME: deliveryData?.stock_data?.[0]?.ttl_trd_qty);
                              let Prev_Volume = parseInt((moment(todayTime).isSame(todayLTP?.DATE, 'day')) && todayMarketHoldTime() === true? deliveryData?.stock_data?.[0]?.ttl_trd_qty:deliveryData?.stock_data?.[1]?.ttl_trd_qty);
      
                              
                              let cuurVolPer = ((Volume - Prev_Volume) * 100) / Prev_Volume;
      
                              let prevDeliv = deliveryData?.stock_data?.[1]?.delivery_per;
                              let deliv = deliveryData?.stock_data?.[0]?.delivery_per;

                              return (
                                <tr
                                  className={`tr_${obj?.id}`}
                                  key={`row_item_${obj.id}`}
                                  id={`row_item_${obj.id}`}
                                >
                                    <td style={{fontSize:'11px'}}>
                                          {moment(obj.datetime).isSame(moment(), 'day')?
                                             moment(obj.datetime).format('hh:mm A'):
                                             moment(obj.datetime).format('DD-MM-YY')}
                                    </td>
                                    <td title={obj.clientName}>{obj.symbol}</td>
                                    <td><StockAction
                                          symbol={symbolName}
                                          delivery={false}
                                          currentPrice={obj?.current_price}
                                          deliveryPer={obj.delivery_per}
                                          hotStar={details?.hotStar}
                                          myFev={details?.myFev}
                                          eventName={obj.orderType}
                                          // slPrice={obj.sl_price}
                                          // gttPrice={obj.target_price}
                                          rowId={`row_item_${obj.id}`}
                                        />
                                    </td>
                                    <td>
                                      <DeliveryGraph
                                        symbol={symbolName}
                                        todayLTP={todayLTP}
                                        date={moment(todayTime).format('YYYY-MM-DD')}
                                      />
                                    </td>
                                    <StockStrength
                                      id={`del_${obj.id}`}
                                      selectedDate={moment(todayTime).format('YYYY-MM-DD')}
                                      symbol={symbolName}
                                      todayLTP={todayLTP}
                                      details={details}
                                      // predictions={obj.prediction}
                                    />

                                    <SectorPanchang
                                      symbol={symbolName}
                                      sector={details?.group_sector}
                                      todayData={todayData}
                                      symbolData={symbolData}
                                      tag = "td"
                                      align = "right"
                                      durationDays = ""
                                    />
                                    <td className="indices" style={{ textAlign: "left" }}>
                                        {(() => {
                                          const label = details?.nifty50
                                            ? "50"
                                            : details?.nifty100
                                            ? "100"
                                            : details?.nifty200
                                            ? "200"
                                            : details?.nifty500
                                            ? "500"
                                            : details?.totalMarket
                                            ? "TM"
                                            : "";
                                          const excludedSeries = ["ETF", "BOND", "MF"];
                                          const showFev =
                                            details?.myFev &&
                                            !excludedSeries.includes(details?.series);
                                          return (
                                            label +
                                            (showFev ? `${label ? ", " : ""}Fev` : "")
                                          );
                                        })()}
                                  </td>
                                  <td style={{background: obj.score > obj.current_score? "#d2ffc6" : '' }} title={obj.current_score}>{obj.score}%</td>
                                  <td style={{background: obj.revenueImpact > 25? "#d2ffc6" : '' }} title={obj.orderValue}>{obj.revenueImpact}%</td>
                                  <td style={{'text-align':'left'}}>{obj.orderType}</td>
                                  <td title={`If CHOCH true | lastHigh: ${Structure.lastHigh} | lastLow: ${Structure.lastLow} | prevHigh: ${Structure.prevHigh} | prevLow: ${Structure.prevLow}`}
                                  style={{
                                      fontSize:'0.67rem',  
                                      textAlign: "left",
                                      backgroundColor: Structure.choch === true && Structure.slope > 1? '#9ce49c': ''
                                    }}
                                
                                >{`${Structure.structure}`}</td>
                                <td>{obj.current_price}</td>
                                <td title={`${todayLTP?.OPEN} | ${todayLTP?.HIGH} | ${todayLTP?.LOW}`}>{todayLTP?.LTP}</td>
                                  <td
                                    style={{
                                      color:
                                        parseFloat(todayLTP?.CHANGEPER) > 0
                                          ? "#1c8b16"
                                          : "#f00",
                                    }}
                                  >
                                    {todayLTP?.CHANGEPER}%
                                  </td>
                                  <td>{(((todayLTP?.LTP - obj.current_price) * 100) / obj.current_price).toFixed(2)}%</td>
                                  <td
                                    style={{
                                      textAlign: "right",
                                      background: EMA21Cross === true? "#e2ffe5":""
                                    }}
                                    title={`EMA20 > SMA20: ${deliveryData?.SMA20}`}
                                  >
                                    {deliveryData?.EMA20}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "right",
                                      background:
                                        parseFloat(deliveryData?.SMA20) >
                                        parseFloat(deliveryData?.SMA50)
                                          ? "#e2ffe5"
                                          : "#fff8f8",
                                    }}
                                    title={`SMA20: ${deliveryData?.SMA20}`}
                                  >
                                    {deliveryData?.SMA50}
                                  </td>
                                  <td title={`${high52w} | ${highDate}`} 
                                    style={{background:high52wPer >= 8 && high52wPer <=40 ? "" : "#fff6f6"}}>
                                    {high52wPer.toFixed(2) + "%"}
                                  </td>

                                  <td title={`${lowDate} | ${highDate}`}>{`${low52w} | ${high52w}`}</td>
                                  <td title={`${cuurVolPer.toFixed(2)}%` }
                                      style={{background: cuurVolPer > 25 ? "#e2ffe5" : ""}}
                                  >
                                    {Number(Prev_Volume).toLocaleString("en-IN")}
                                  </td>
                                  <td title={deliv > prevDeliv? `${prevDeliv}%`:''}
                                    style={{background: deliv > prevDeliv? "#e2ffe5": ""}}
                                  > 
                                    {deliv}%</td>
                                                                <td style={{ textAlign: "center", padding:"0px"}}>
                                                                  <button type="button" class="removelist" onClick={(e) => itemRemoveHandler(e, obj.id)}></button>
                                                                <a
                                                                  title="News"
                                                                  className="newsicon"
                                                                  href={`https://www.google.com/ai?q=${AIPromptForStock1(symbolName)}`}
                                                                  target="_blank"
                                                                  rel="noopener noreferrer"
                                                                ></a>
                                                                </td>
                                        

                                </tr>
                              );
                            })
                          )}
                      </tbody>
                </table>
            
            
          </div>
      </div>
    </React.Fragment>
  );
};
export default NewOrderPage;
